import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { RoleAccountGuard } from '../../guards/role-account.guard';
import { campaignsComponent } from '../../pages/campaigns/campaigns.component';/* 
import { stocksComponent } from '../../pages/stocks/stocks.component'; */
export const campaignsRoutes: Routes = [
 /*  {
    path: 'campaigns/stocks',
    component: stocksComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.stocks', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier'] },
  },
  {
    path: 'campaigns/stocks/:reference',
    component: stocksComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.stocks', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier'] },
  }, */
  {
    path: 'campaigns/enabled',
    component: campaignsComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.enabled', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier','broker'] },
  },
  {
    path: 'campaigns/under-review',
    component: campaignsComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.under_review', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier'] },
  },
  {
    path: 'campaigns/paused',
    component: campaignsComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.paused', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier'] },
  },
  {
    path: 'campaigns/finished',
    component: campaignsComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.finished', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier'] },
  },
  {
    path: 'campaigns/cancelled',
    component: campaignsComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.cancelled', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier'] },
  },
  {
    path: 'campaigns',
    component: campaignsComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.campaigns', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier', 'broker'] },
  },
  {
    path: 'campaigns/:reference',
    component: campaignsComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.campaigns', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier', 'broker'] },
  },

];


export function getFilteredCampaignsRoutes(accountType: string, role: string): Routes {
  return campaignsRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
